
export var myhost ="https://adminmaghar.maghar41.ir/adminapi";
//export var myhost ="https://adminmaghar.nickpars.ir/adminapi";



//export var myhost ="http://localhost/adminapi";




//var myhost ="https://test.nickpars.ir/adminapi";
// https://test.nickpars.ir/api/lib/



